module.exports = __webpack_public_path__ + "static/media/background_shape.ec37d961.svg";